import { api } from '../api';

// ApiResponse envelope → inner payload. UserDTO endpoints return
// { success, data: UserDTO }.
const unwrap = (r) => r?.data?.data ?? r?.data;

const toArray = (body) =>
  body?.data?.content
  ?? body?.content
  ?? (Array.isArray(body?.data) ? body.data : null)
  ?? (Array.isArray(body) ? body : []);

export default {
  /** Current user — carries dealershipId + roles, used to scope the team view. */
  me:         ()         => api.get('/v1/users/me').then(unwrap),

  /**
   * Super-admin-only flat list. Left returning the raw ApiResponse envelope
   * for backward-compat with useDirectory (which digs into .data.content).
   */
  list:       (params)   => api.get('/v1/users', { params }).then(r => r.data),

  /**
   * Users for one dealership (Dealer Principal / Super Admin).
   * Returns a plain array of UserDTO regardless of the paging envelope.
   */
  listByDealership: (dealershipId, params) =>
    api.get(`/v1/users/dealership/${dealershipId}`, { params })
       .then(r => toArray(r.data)),

  /** Active staff of the caller's own dealership — open to every role (booking pickers). */
  directory:  ()         => api.get('/v1/users/directory').then(r => toArray(r.data)),

  get:        (id)       => api.get(`/v1/users/${id}`).then(unwrap),

  /** Invite a user to the caller's dealership. body: { email, firstName, lastName, roles[] } */
  create:     (body)     => api.post('/v1/users', body).then(unwrap),

  /** Update profile / roles. body: { firstName, lastName, roles[] } — email is Keycloak-owned. */
  update:     (id, body) => api.put(`/v1/users/${id}`, body).then(unwrap),

  activate:   (id)       => api.put(`/v1/users/${id}/activate`).then(unwrap),
  deactivate: (id)       => api.put(`/v1/users/${id}/deactivate`).then(unwrap),
  delete:     (id)       => api.delete(`/v1/users/${id}`).then(r => r.data),
};
